import React, { useState } from 'react';
import { HashLink } from 'react-router-hash-link';
import { BiMenu } from 'react-icons/bi';
import { AiOutlineCloseCircle } from 'react-icons/ai';

function Navbar() {

  const [showMenu, setShowMenu] = useState('false');

  return (
    <div className='nav-cont'>
        <div className="logo">
          <img src="/logo192.png" alt="Logo of Explore Era website" />
          <HashLink smooth to='#'>EXPLORE ERA</HashLink>
        </div>

        {(showMenu === 'false') ? <BiMenu className='menu' onClick={() => setShowMenu('true')} /> : <AiOutlineCloseCircle className='close' onClick={() => setShowMenu('false')} />}

    {(showMenu === 'true') && (
      <nav>
      <HashLink smooth to="#">Home</HashLink>
      <HashLink smooth to="#about">About</HashLink>
      <HashLink smooth to='#travel'>Travel</HashLink>
      <HashLink smooth to='#test'>Testimonials</HashLink>
      <HashLink smooth to='#contact'>Contact</HashLink>
      </nav>
    )}

    </div>
  )
}

export default Navbar;